import Label from './Label.styled';

export * from './ExternalUserLabels';
export default Label;
